import {useEffect} from "react";
import i18n from './i18n';


export function isRtl() {
    return i18n.dir() === 'rtl'
}
